// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerWrap {
  position: absolute;
  width: 332px;
  height: 32px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  z-index: 12;
  transition: 0.3s;
  border-radius: 8px;
  display: inline-block;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 16px;
  text-align: center;
}
.headerWrap .webViewerName {
  font-size: 16px;
  font-weight: 500;
  display: inline-block;
  width: 70%;
  line-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mobileHeaderWrap {
  position: relative;
  width: 100vw;
  height: 32px;
  font-size: 16px;
  font-weight: 500;
  color: #1b1c1e;
  z-index: 10;
  transition: 0.3s;
  background-color: white;
  display: inline-block;
  text-align: center;
}
.mobileHeaderWrap .webViewerName {
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.listWrap {
  width: 332px;
  position: absolute;
  z-index: 12;
  background-color: white;
  overflow: hidden;
  border-radius: 8px;
  left: 50%;
  transform: translateX(-50%);
}
.listWrap .listItem {
  width: 100%;
  height: 54px;
  border-radius: 4px;
  position: relative;
  margin: 0px 0 4px 0;
  transition: 0.3s;
}
.listWrap .listItem .patientName {
  display: inline-block;
  margin-left: 10px;
  font-size: 14px;
  color: black;
  font-weight: 500;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.listWrap .listItem .openBtn {
  position: absolute;
  width: 53px;
  height: 25px;
  background-color: #D3D8DE;
  border-radius: 8px;
  float: right;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  text-align: center;
  line-height: 1.5;
  color: black;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  display: none;
}
.listWrap .listItem .deleteBtn {
  float: right;
  font-size: 18px;
  margin-right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
  position: relative;
  cursor: pointer;
  display: none;
}
.listWrap .listItem:hover {
  background-color: #F3F4F5;
}
.listWrap .listItem:hover .deleteBtn {
  display: inline-block !important;
}
.listWrap .listItem:hover .openBtn {
  display: block;
}
.listWrap .bscroll-vertical-scrollbar {
  right: 3px !important;
  width: 9px !important;
}
.listWrap .bscroll-vertical-scrollbar .bscroll-indicator {
  border-radius: 9px !important;
}
.listWrap .currentItemStyle {
  background-color: #F3F4F5;
}
.listWrap .currentItemStyle .deleteBtn {
  display: inline-block !important;
}
.listWrap .currentItemStyle .openBtn {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/PatientsList/index.less"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EAEA,WAAA;EACA,gBAAA;EAEA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,2BAAA;EAEA,gBAAA;EACA,kBAAA;AAHF;AAdA;EAmBI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;AAOA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAEA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;AANF;AANA;EAeI,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AANJ;AAWA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AATF;AACA;EAWI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AATJ;AAPA;EAmBM,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AATN;AAlBA;EA+BM,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;AAVN;AApCA;EAkDM,YAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAXN;AAgBI;EACE,yBAAA;AAdN;AAaI;EAII,gCAAA;AAdR;AAUI;EAQI,cAAA;AAfR;AAxDA;EA6EI,qBAAA;EACA,qBAAA;AAlBJ;AA5DA;EAiFM,6BAAA;AAlBN;AA/DA;EAuFI,yBAAA;AArBJ;AAlEA;EA0FM,gCAAA;AArBN;AArEA;EA8FM,cAAA;AAtBN","sourcesContent":["// webviewer name style\n.headerWrap {\n  position: absolute;\n  width: 332px;\n  height: 32px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n  //cursor: pointer;\n  z-index: 12;\n  transition: .3s;\n  //background-color: #f3f4f5;\n  border-radius: 8px;\n  display: inline-block;\n  left: 50%;\n  transform: translateX(-50%);\n\n  margin-top: 16px;\n  text-align: center;\n  .webViewerName {\n    font-size: 16px;\n    font-weight: 500;\n    display: inline-block;\n    width: 70%;\n    line-height: 32px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n  }\n}\n\n.mobileHeaderWrap {\n  position: relative;\n  width: 100vw;\n  height: 32px;\n  font-size: 16px;\n  font-weight: 500;\n  color: rgb(27, 28, 30);\n  //cursor: pointer;\n  z-index: 10;\n  transition: .3s;\n  background-color: white;\n  display: inline-block;\n  text-align: center;\n\n  .webViewerName {\n    font-size: 18px;\n    font-weight: bold;\n    display: inline-block;\n    width: 70%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n  }\n}\n\n.listWrap {\n  width: 332px;\n  position: absolute;\n  z-index: 12;\n  background-color: white;\n  overflow: hidden;\n  border-radius: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n\n  .listItem {\n    width: 100%;\n    height: 54px;\n    border-radius: 4px;\n    position: relative;\n    margin: 0px 0 4px 0;\n    transition: .3s;\n\n    .patientName {\n      display: inline-block;\n      margin-left: 10px;\n      font-size: 14px;\n      color: black;\n      font-weight: 500;\n      max-width: 150px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    .openBtn {\n      position: absolute;\n      width: 53px;\n      height: 25px;\n      background-color: #D3D8DE;\n      border-radius: 8px;\n      float: right;\n      top: 50%;\n      right: 40px;\n      transform: translateY(-50%);\n      text-align: center;\n      line-height: 1.5;\n      color: black;\n      font-weight: 500;\n      font-size: 14px;\n      cursor: pointer;\n      display: none;\n    }\n\n    .deleteBtn {\n      float: right;\n      font-size: 18px;\n      margin-right: 12px;\n      top: 50%;\n      transform: translateY(-50%);\n      display: inline-block;\n      position: relative;\n      cursor: pointer;\n      display: none;\n    }\n\n\n\n    &:hover {\n      background-color: #F3F4F5;\n\n      .deleteBtn {\n        display: inline-block !important;\n      }\n\n      .openBtn {\n        display: block;\n      }\n    }\n  }\n\n  .bscroll-vertical-scrollbar {\n    right: 3px !important;\n    width: 9px !important;\n\n    .bscroll-indicator {\n      border-radius: 9px !important;\n    }\n\n  }\n\n  .currentItemStyle {\n    background-color: #F3F4F5;\n\n    .deleteBtn {\n      display: inline-block !important;\n    }\n\n    .openBtn {\n      display: block;\n    }\n  }\n}\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
